import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTheme } from "../ThemeProvider";
import { dialogs } from "../../context/DialogContext";
import BuscadorContacto from "../contactos/BuscadorContacto";
import CamposNotariaParteExpediente from "./CamposNotariaParteExpediente";
import { FORM_PROPIETARIO_VACIO, datosNotariaDesdeContacto, formularioPropietarioInicial, fusionarNotariaConPartesExistentes } from "../../utils/parteExpedienteCampos";

export default function ModalAnadirPropietarioExpediente({ isOpen, onClose, onConfirm, propietariosActuales = [] }) {
  const { theme } = useTheme();
  const t = theme.colors;
  const isDark = theme.name === "dark";
  const tx = isDark ? "#ffffff" : t.textPrimary;

  const [form, setForm] = useState(() => formularioPropietarioInicial(propietariosActuales));

  useEffect(() => {
    if (isOpen) setForm(formularioPropietarioInicial(propietariosActuales));
  }, [isOpen]);

  if (!isOpen) return null;

  const reset = () => setForm(formularioPropietarioInicial(propietariosActuales));

  const inp = {
    padding: "6px 8px", borderRadius: 6, fontSize: 12, width: "100%",
    background: isDark ? "#1a2030" : t.inputBg,
    border: `1px solid ${isDark ? "#5a6a80" : t.inputBorder}`,
    color: tx, outline: "none", fontFamily: "inherit", boxSizing: "border-box",
  };
  const sel = { ...inp, cursor: "pointer" };
  const lbl = { fontSize: 10, fontWeight: 700, opacity: 0.75, display: "block", marginBottom: 3 };

  const seleccionarContacto = (c) => {
    if (propietariosActuales.some((p) => p.contacto_id === c.id)) {
      dialogs.alert("Este contacto ya está como propietario.");
      return;
    }
    const extra = datosNotariaDesdeContacto(c);
    setForm(fusionarNotariaConPartesExistentes({
      ...FORM_PROPIETARIO_VACIO,
      contacto_id: c.id,
      nombre: c.nombre || "",
      apellidos: c.apellidos || "",
      direccion: extra.direccion || c.direccion || "",
      nacionalidad: extra.nacionalidad || "",
      telefono: c.telefono || "",
      email: c.email || "",
    }, propietariosActuales));
  };

  const confirmar = () => {
    if (!form.nombre?.trim() && !form.apellidos?.trim()) {
      dialogs.alert("Indica nombre o apellidos del vendedor.");
      return;
    }
    onConfirm({
      contacto_id: form.contacto_id,
      nombre: form.nombre.trim(),
      apellidos: form.apellidos.trim(),
      direccion: form.direccion.trim(),
      estado_civil: form.estado_civil,
      regimen_matrimonial: form.regimen_matrimonial,
      profesion: form.profesion.trim(),
      sexo: form.sexo,
      nacionalidad: form.nacionalidad.trim(),
      nuda_propiedad: form.nuda_propiedad,
      pleno_dominio: form.pleno_dominio,
      usufructo: form.usufructo,
      telefono: form.telefono,
      email: form.email,
    });
    reset();
    onClose();
  };

  return createPortal(
    <div style={{
      position: "fixed", inset: 0, zIndex: 12000, background: "rgba(0,0,0,0.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{
        width: 520, maxWidth: "94vw", maxHeight: "90vh", overflowY: "auto",
        background: isDark ? "#1e2330" : "#fff",
        borderRadius: 10, padding: 16, border: `1px solid ${isDark ? "#4a5568" : t.border}`, color: tx,
      }} onMouseDown={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 10 }}>Añadir vendedor</div>
        <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 4, opacity: 0.8 }}>Buscar contacto</div>
        <BuscadorContacto isDark={isDark} tipo="propietario" compact placeholder="Nombre, teléfono..." onSeleccionar={seleccionarContacto} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 12 }}>
          <div>
            <label style={lbl}>Nombre</label>
            <input style={inp} value={form.nombre} onChange={(e) => setForm((f) => ({ ...f, nombre: e.target.value }))} />
          </div>
          <div>
            <label style={lbl}>Apellidos</label>
            <input style={inp} value={form.apellidos} onChange={(e) => setForm((f) => ({ ...f, apellidos: e.target.value }))} />
          </div>
          <div>
            <label style={lbl}>Nuda prop.</label>
            <input style={{ ...inp, textAlign: "right" }} value={form.nuda_propiedad} onChange={(e) => setForm((f) => ({ ...f, nuda_propiedad: e.target.value }))} />
          </div>
          <div>
            <label style={lbl}>Pleno dom.</label>
            <input style={{ ...inp, textAlign: "right" }} value={form.pleno_dominio} onChange={(e) => setForm((f) => ({ ...f, pleno_dominio: e.target.value }))} />
          </div>
          <div>
            <label style={lbl}>Usufructo</label>
            <input style={{ ...inp, textAlign: "right" }} value={form.usufructo} onChange={(e) => setForm((f) => ({ ...f, usufructo: e.target.value }))} />
          </div>
        </div>
        <CamposNotariaParteExpediente form={form} setForm={setForm} inp={inp} sel={sel} lbl={lbl} />
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
          <button type="button" onClick={() => { reset(); onClose(); }}
            style={{ padding: "6px 14px", borderRadius: 6, border: `1px solid ${t.border}`, background: "transparent", color: tx, cursor: "pointer" }}>
            Cancelar
          </button>
          <button type="button" onClick={confirmar}
            style={{ padding: "6px 14px", borderRadius: 6, border: "none", background: "#7c3aed", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
            Añadir
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
